<template>
  <div class="row no-padd" ref="enderecoForm" v-if="matricula" >
    <template v-if="showEnderecoAlunoSwitch">
      <div class="col-md-12 no-padd-left">
        <!-- <h5 class="color-text">Utilizar mesmo endereço do aluno?</h5> -->
        <switch-control
          labelOn="Utilizar mesmo endereço do aluno"
          labelOff="Não utilizar mesmo endereço do aluno"
          v-model:checked="utilizarEnderecoAluno"
          @change="toggleEnderecoAluno"
          invert
        ></switch-control>
      </div>
    </template>
    <div class="col-md-4 form-group no-padd-left">
      <label>CEP</label>
      <input-control 
        v-model="matricula[branch].endereco.cep" 
        placeholder="00000-000" 
        name="cep" 
        type="text" 
        :valid="valid.cep" 
        :disabled="loadingInputContent || effectiveDisabledAll" 
        @keyup="valid.cep = true; buscaCep()"
        @focus="triggerTip(branch,'cep')"
        masking="cep"
        required
      />
      <div v-if="cepError" class="mt-2">
        <card boxed spacing="mini">
          <strong>Ops! Não encontramos seu CEP.</strong> <br/>
          Isso às vezes acontece em locais que ainda não estão cadastrados nos Correios, como novos condomínios ou loteamentos.
          Se for o seu caso, você pode usar o <strong>CEP da portaria</strong> e, no campo de <strong>complemento</strong>, colocar o número e o nome da sua rua ou casa.
        </card>
      </div>
    </div>
    <div class="col-md-8 form-group no-padd-left">
      <label>Logradouro</label>
      <input-control 
        v-model="matricula[branch].endereco.logradouro" 
        placeholder="Avenida Paulista" 
        name="logradouro"
        type="text"
        :valid="valid.logradouro"
        :disabled="effectiveDisabledAll || isBasic"
        readonly
        @keyup="valid.logradouro = true"
        @focus="triggerTip(branch,'logradouro')"
        required
      />
    </div>
    <div class="col-md-2 form-group no-padd-left">
      <label>Número</label>
      <input-control 
        v-model="matricula[branch].endereco.numero" 
        placeholder="Número"
        name="numero"
        type="text"
        maxlength="6"
        inputmode="numeric"
        pattern="[0-9]*"
        digits-only
        :valid="valid.numero"
        :disabled="disabledByCep || effectiveDisabledAll"
        @keyup="valid.numero = true"
        @focus="triggerTip(branch,'numero')"
        ref="number"
        required
      />
    </div>
    <div class="col-md-4 form-group no-padd-left">
      <label>Complemento</label>
      <input-control 
        v-model="matricula[branch].endereco.complemento" 
        placeholder="Casa, Apto, etc." 
        name="complemento" 
        type="text" 
        :disabled="disabledByCep || effectiveDisabledAll"
        @focus="triggerTip(branch,'complemento')"
      />
    </div>
    <div class="col-md-6 form-group no-padd-left">
      <label>Bairro</label>
      <input-control 
        v-model="matricula[branch].endereco.bairro" 
        placeholder="Jardins" 
        name="bairro"
        type="text"
        :valid="valid.bairro"
        :disabled="effectiveDisabledAll || isBasic"
        readonly
        @keyup="valid.bairro = true"
        @focus="triggerTip(branch,'bairro')"
        required
      />
    </div>
    <div class="col-md-6 form-group no-padd-left">
      <label>Cidade</label>
        <select-control 
          v-model="matricula[branch].endereco.idCidade" 
          placeholder="São Paulo" 
          :options="options.cidades" 
          name="idCidade"
          type="text"
          :valid="valid.idCidade"
          :disabled="effectiveDisabledAll || isBasic"
          readonly
          @change="valid.idCidade = true; fillNome('cidades', matricula[branch].endereco.idCidade)"
          @focus="triggerTip(branch,'idCidade')"
          required
        />
        <input type="hidden" name="nomeCidade" v-model="matricula[branch].endereco.nomeCidade" />
    </div>
    <div class="col-md-2 form-group no-padd-left">
      <label>UF</label>
      <select-control 
        v-model="matricula[branch].endereco.idUf" 
        placeholder="SP" 
        :options="options.ufs" 
        name="idUf"
        type="text"
        :valid="valid.idUf"
        readonly
        :disabled="effectiveDisabledAll || isBasic"
        @change="valid.idUf = true; fillNome('ufs', matricula[branch].endereco.idUf)"
        @focus="triggerTip(branch,'idUf')"
        required
      />
      <input type="hidden" name="nomeUf" v-model="matricula[branch].endereco.nomeUf" />
    </div>
    <div class="col-md-3 form-group checkbox-only" v-if="hasEndereco">
      <!-- <label class="check-control">
        <input type="checkbox" class="check" name="addForAll" v-model="addForAll" @change="addEnderecoParaTodos"/>
        <span>
          Utilizar o mesmo endereço para todas as pessoas desta matrícula 
        </span>
      </label> -->
    </div>
  </div>
</template>

<script>
import UserService from '@/services/user.service'
import FormService from '@/services/form.service'
import { ADDRESS_NUMBER_ERROR, isAddressNumberValid } from '@/services/address-number.service'
import { createSelectOptions, getCEP } from '@/services/utils.service'

export default {
  props: {
    autoPopulate: {
      type: Object
    },
    branch: {
      type: String
    },
    child: {
      type: String
    },
    action: {
      type: String
    },
    disabledAll: {
      type: Boolean,
      default: false
    },
    showAlunoSwitch: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    autoPopulate ( value ) {
      if ( value ) {
        this.matricula[this.branch].endereco = value
        this.hasEndereco = true
      }
    }
  },
  data () {
    return {
      matricula: null,
      valid: {
        cep: true,
        logradouro: true,
        numero: true,
        bairro: true,
        idUf: true,
        idCidade: true
      },
      options: {
        ufs: [],
        cidades: []
      },
      wait: {
        ufs: false,
        cidades: false
      },
      cepError: false,
      cepErrorMsg: '',
      loading: false,
      loadingInputContent: false,
      searchCepLoop: null,
      hasEndereco: false,
      addForAll: false,
      utilizarEnderecoAluno: false,
      oldEndereco: null
    }
  },
  mounted () {
    this.$store.dispatch('matricula/get').then(response => {
      // console.log("matricula:", response)
      this.matricula = response
      this.oldEndereco = { ...this.matricula[this.branch].endereco }
      window.spinner.emit("open")
      this.loading = true
      this.loadingInputContent = true

      this.getUfs()
      this.getCidades()
    })
    
  },
  computed: {
    isBasic () {
      return this.branch === 'Basic'
    },
    showEnderecoAlunoSwitch () {
      return !['aluno', 'Basic', 'BasicAluno'].includes(this.branch)
    },
    effectiveDisabledAll () {
      return this.disabledAll || this.utilizarEnderecoAluno
    },
    disabledByCep () {
      return this.loadingInputContent || this.action == 'ver' || this.cepError
    }
  },
  methods: {
    getUfs () {
      UserService.ufs().then(
        response => {
          if ( response.data.length > 0 ) {
            console.log('ufs:', response.data)
            this.options.ufs = createSelectOptions(response.data,'idUf', 'uf')
            this.wait.ufs = true
            this.stopSpinner()
          } else {
            //
          }
        },
        error => {
          console.error(error)
          window.spinner.emit("close")
          this.loading = false
          this.loadingInputContent = false
        }
      )
    },
    getCidades () {
      UserService.cidades().then(
        response => {
          if ( response.data.length > 0 ) {
            console.log('cidades:', response.data)
            this.wait.cidades = true
            this.options.cidades = createSelectOptions(response.data,'idCidade', 'nome')
            this.stopSpinner()
          } else {
            //
          }
        },
        error => {
          console.error(error)
          window.spinner.emit("close")
          this.loading = false
          this.loadingInputContent = false
        }
      )
    },
    stopSpinner () {
      const done = !Object.values(this.wait).includes(false)
      console.log("done:", done)
      if ( done ) {
        this.loading = false
        this.loadingInputContent = false
        this.$emit('onload')
      }
    },
    fillNome ( target, data ) {
      console.log("fillNome:", target)
      console.log("data:", data)
    },
    buscaCep () {
      const cep = this.matricula[this.branch].endereco.cep
      this.cepError = false
      this.cepErrorMsg = ''

      if (cep && cep.length == 9) {
        if (this.searchCepLoop) clearTimeout(this.searchCepLoop)

        this.searchCepLoop = setTimeout(() => {
          window.spinner.emit('open')
          this.loadingInputContent = true

          getCEP(cep).then(
            response => {
              console.log("getCEP:", response)
              const notFound = response?.data?.erro === true || response?.data?.erro === 'true'

              if (notFound) {
                this.valid.cep = false
                this.cepError = true
              } else {
                this.cepError = false
                this.populateEnderecoByCep(response.data)
              }

              this.loadingInputContent = false
              window.spinner.emit('close')
            },
            error => {
              console.error(error)
              this.cepError = true
              this.loadingInputContent = false
              window.spinner.emit('close')
            }
          )
        }, 300)
      }
    },
    populateEnderecoByCep ( data ) {
      this.matricula[this.branch].endereco.logradouro = data.logradouro
      this.matricula[this.branch].endereco.bairro = data.bairro
      this.matricula[this.branch].endereco.nomeCidade = data.localidade
      this.matricula[this.branch].endereco.nomeUf = data.uf
      

      const searchCidades = this.options.cidades.filter( k => {
        return k.label.toLowerCase() == data.localidade.toLowerCase()
      })

      const idCidade = searchCidades[0].value
      this.matricula[this.branch].endereco.idCidade = idCidade

      const searchUf = this.options.ufs.filter( k => {
        return k.label.toLowerCase() == data.uf.toLowerCase()
      })

      const idUf = searchUf[0].value
      this.matricula[this.branch].endereco.idUf = idUf

      console.log(this.$refs.number)
      this.$refs.number.$refs.input.focus()

      this.hasEndereco = true
    },
    toggleEnderecoAluno () {
      if ( this.utilizarEnderecoAluno ) {
        this.matricula[this.branch].endereco = this.matricula.aluno.endereco
        if ( this.matricula[this.branch].endereco.idEndereco ) {
          delete this.matricula[this.branch].endereco.idEndereco
        }
      } else {
        this.matricula[this.branch].endereco = this.oldEndereco
      }
    },
    addEnderecoParaTodos () {
      console.log('addEnderecoParaTodos:', this.matricula)
    },
    validate () {
      const valid = FormService.validate(this.$refs.enderecoForm, this.valid)
      if (!isAddressNumberValid(this.matricula[this.branch].endereco.numero)) {
        this.valid.numero = false
        valid.response = false
        window.toaster.emit('open', { style: 'error', message: ADDRESS_NUMBER_ERROR, floater: true })
      }
      console.log("validate:", valid)
      return valid
    },
    triggerTip ( branch, field ) {
    const tip = {
      branch: branch,
      field: field
    }
    window.mattip.emit("add", tip)
  }
  }
}
</script>

<style lang="scss" scoped>

</style>
